import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'izy-version-easter-egg-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  standalone: true,
  templateUrl: './version-easter-egg-dialog.component.html',
  styleUrl: './version-easter-egg-dialog.component.scss',
})
export class VersionEasterEggDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<VersionEasterEggDialogComponent>,
  ) {}
}
